document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-scroll-logo]').forEach((scrollLogo) => {
    if (scrollLogo.dataset.scrollLogoAlwaysVisible === 'true') {
      scrollLogo.style.opacity = '1';
      return;
    }

    const threshold = parseFloat(scrollLogo.dataset.scrollThreshold) / 100;

    const onScroll = () => {
      const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
      const triggerPoint = pageHeight * threshold;
      scrollLogo.style.opacity = window.scrollY >= triggerPoint ? '0' : '1';
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
});
